import { API_URL } from '../constants/routes';
import { postRoute } from '../helpers/apiCalls';

export const signinUser = async (data) => postRoute(`${API_URL}/sign`, data);
